<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-6xl mx-auto px-4">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-6">
        <button @click="$router.push('/proprietario')" class="flex items-center gap-2 text-slate-500 hover:text-orange-600 transition-colors mb-4 group">
          <v-icon small class="group-hover:-translate-x-1 transition-transform" color="inherit">mdi-arrow-left</v-icon>
          <span class="text-[10px] font-black uppercase tracking-widest">Voltar para listagem</span>
        </button>
        <div class="flex items-center justify-between">
            <div>
                <h1 class="text-3xl font-black text-slate-800 uppercase tracking-tight">
                    {{ id ? 'Editar Proprietário' : 'Novo Proprietário' }}
                </h1>
                <p class="text-sm text-slate-500 font-medium mt-1">Gestão de proprietários de veículos</p>
            </div>
        </div>
      </div>

      <div class="space-y-8 pb-24">
        <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
          <div class="space-y-8">
            <!-- FORMULÁRIO -->
            <section class="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
                <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
                    <v-icon color="orange" small>mdi-account-plus-outline</v-icon>
                    <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                        {{ id ? 'EDITAR DADOS DO PROPRIETÁRIO' : 'DADOS DO NOVO PROPRIETÁRIO' }}
                    </h2>
                </div>

                <div class="p-8">
                    <v-row>
                        <!-- Prefeitura -->
                        <v-col cols="12" v-if="isAdmin">
                            <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Prefeituras Vinculadas</label>
                            <v-autocomplete
                              v-model="data.prefecture_ids"
                              :items="prefectures"
                              :readonly="!isAdmin && isPrefecture"
                              item-text="prefecture_social_name"
                              item-value="prefecture_id"
                              placeholder="Selecione as Prefeituras..."
                              solo flat dense hide-details
                              multiple
                              chips
                              small-chips
                              deletable-chips
                              class="bg-slate-50 border border-slate-100 rounded-lg custom-select-main font-bold uppercase"
                              height="auto"
                            />
                        </v-col>

                        <!-- Tipo de Cadastro -->
                        <v-col cols="12">
                          <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Tipo de Pessoa</label>
                          <div class="flex items-center gap-8 bg-slate-50 border border-slate-100 rounded-lg px-4 h-12">
                              <label class="flex items-center gap-3 cursor-pointer group">
                                  <input type="radio" :value="false" v-model="data.type" class="w-4 h-4 text-orange-500 border-slate-300 focus:ring-orange-500 transition-all">
                                  <span class="text-[11px] font-black text-slate-500 uppercase tracking-widest group-hover:text-slate-800 transition-colors">Pessoa Física</span>
                              </label>
                              <label class="flex items-center gap-3 cursor-pointer group">
                                  <input type="radio" :value="true" v-model="data.type" class="w-4 h-4 text-orange-500 border-slate-300 focus:ring-orange-500 transition-all">
                                  <span class="text-[11px] font-black text-slate-500 uppercase tracking-widest group-hover:text-slate-800 transition-colors">Pessoa Jurídica</span>
                              </label>
                          </div>
                        </v-col>

                        <!-- Nome/Razão Social -->
                        <v-col cols="12" md="8">
                            <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">
                               {{ data.type ? 'Razão Social' : 'Nome Completo' }}
                            </label>
                            <v-text-field
                              v-model="data.name"
                              :rules="fieldRules"
                              placeholder="DIGITE O NOME OU RAZÃO SOCIAL..."
                              solo flat dense hide-details
                              class="bg-slate-50 border border-slate-100 rounded-lg custom-select-main font-bold uppercase"
                              height="48"
                            />
                        </v-col>

                        <!-- CPF/CNPJ -->
                        <v-col cols="12" md="4">
                            <label class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">
                               {{ data.type ? 'CNPJ' : 'CPF' }}
                            </label>
                            <v-text-field
                              v-model="data.document"
                              :maxlength="data.type ? 18 : 14"
                              @input="data.type ? setCnpj(data.document) : setCpf(data.document)"
                              :error="data.type ? !validCnpj(data.document) : !validCpf(data.document)"
                              placeholder="000.000.000-00"
                              solo flat dense hide-details
                              class="bg-slate-50 border border-slate-100 rounded-lg custom-select-main font-bold"
                              height="48"
                            />
                        </v-col>
                    </v-row>
                </div>

                <!-- FOOTER AÇÕES -->
                <div class="bg-slate-50 px-6 py-4 border-t border-slate-100 flex justify-end items-center gap-4" style="border-radius: 0 0 12px 12px;">
                  <button
                    type="button"
                    @click="$router.push('/proprietario')"
                    style="background: none; border: none; cursor: pointer; white-space: nowrap;"
                    class="text-slate-400 hover:text-slate-600 font-bold text-[11px] uppercase tracking-widest transition-colors"
                  >
                    CANCELAR
                  </button>
                  <button
                    type="button"
                    @click="validate"
                    :disabled="!valid || loader"
                    style="background-color: #f37021; color: white; display: inline-flex; align-items: center; gap: 8px; border-radius: 8px; padding: 0 24px; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; cursor: pointer; height: 42px; width: auto; flex-shrink: 0;"
                  >
                    <v-icon v-if="loader" small class="animate-spin" color="white">mdi-loading</v-icon>
                    <v-icon v-else small color="white">{{ id ? 'mdi-check' : 'mdi-check' }}</v-icon>
                    <span>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
                  </button>
                </div>
            </section>
          </div>
        </v-form>
      </div>
    </div>

    <!-- NOTIFICAÇÕES -->
    <v-snackbar
      v-model="snack.show"
      :color="snack.color"
      timeout="4000"
      rounded="xl"
      elevation="24"
      class="mb-8"
    >
      <div class="flex items-center gap-3">
        <v-icon color="white">{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
        <span class="text-xs font-black uppercase tracking-widest">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snack.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    prefectures: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      id: null,
      prefecture_ids: [],
      name: "",
      document: "",
      type: null,
    },
  }),
  computed: {
    isAdmin() {
      const user = this.$store.getters.getUserData;
      return user && user.group_id == 1;
    },
    isPrefecture() {
      const user = this.$store.getters.getUserData;
      return user && user.table_key === 'prefectures';
    },
  },
  created() {
    this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    
    if (this.isPrefecture && !this.isAdmin) {
      this.data.prefecture_ids = [this.$store.getters.getUserData.table_id];
    }

    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/proprietario/${this.id}`).then((r) => {
        this.data = r.data[0];
        delete this.data.created_at;
        if (!this.data.prefecture_ids) {
          this.data.prefecture_ids = this.data.prefecture_id ? [this.data.prefecture_id] : [];
        }
        this.$store.dispatch("setLoader", false);
      });
    }
  },
  methods: {
    setCnpj(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/, "$1.$2");
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
      this.data.document = v;
    },
    setCpf(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/(\d{3})(\d)/, "$1.$2");
      v = v.replace(/(\d{3})(\d)/, "$1.$2");
      v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      this.data.document = v;
    },
    validCnpj(v) {
      let cnpj = v.replace(/\D/gim, "");

      // Valida a quantidade de caracteres
      if (cnpj.length !== 14) return false;

      // Elimina inválidos com todos os caracteres iguais
      if (/^(\d)\1+$/.test(cnpj)) return false;

      // Cáculo de validação
      let t = cnpj.length - 2,
        d = cnpj.substring(t),
        d1 = parseInt(d.charAt(0)),
        d2 = parseInt(d.charAt(1)),
        calc = (x) => {
          let n = cnpj.substring(0, x),
            y = x - 7,
            s = 0,
            r = 0;

          for (let i = x; i >= 1; i--) {
            s += n.charAt(x - i) * y--;
            if (y < 2) y = 9;
          }

          r = 11 - (s % 11);
          return r > 9 ? 0 : r;
        };
      return calc(t) === d1 && calc(t + 1) === d2;
    },
    validCpf(cpf) {
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    },
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/proprietario/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            setTimeout(() => {
              this.$router.push("/proprietario");
            }, 1500);
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/proprietario", this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            setTimeout(() => {
              this.$router.push("/proprietario");
            }, 1500);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.sci-page-wrapper {
  background-color: #f8fafc;
  min-height: 100vh;
  padding: 80px 20px;
}

.custom-select-main >>> .v-input__control .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 16px !important;
}

.custom-select-main >>> input,
.custom-select-main >>> .v-select__selection {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.8rem;
  color: #334155 !important;
}

.custom-snack >>> .v-snack__wrapper {
  border-radius: 12px !important;
}
</style>
